import { chain } from 'lodash';
import { orderbookMap2Array } from '@/utils/grouping';
import { Board, OrderbookMap, OrderbookSide } from '@/types/orderbook';

interface Boards {
  bids: Board[];
  asks: Board[];
}

export class Orderbook {
  private bidsAsks: OrderbookMap = {
    bids: new Map(),
    asks: new Map(),
  };
  private isSnapshot = false;
  public getOrderbook() {
    if (this.isSnapshot) {
      return orderbookMap2Array(this.bidsAsks);
    }
  }
  public _setSnapshot(data: Boards) {
    this.isSnapshot = true;
    Object.keys(this.bidsAsks).forEach((kind) => {
      this.bidsAsks[kind as OrderbookSide].clear();
      this.bidsAsks[kind as OrderbookSide] = new Map(
        chain(data[kind as OrderbookSide])
          .keyBy('price')
          .toPairs()
          .value(),
      );
    });
  }
  public _setBoard(data: Boards) {
    Object.keys(this.bidsAsks).forEach((kind) => {
      data[kind as keyof Boards].forEach((entry) => {
        if (entry.size === 0.0) {
          this.bidsAsks[kind as OrderbookSide].delete(entry.price + '');
        } else {
          this.bidsAsks[kind as OrderbookSide].set(entry.price + '', entry);
        }
      });
    });
  }
}
